/* A short buzz on the two moments worth feeling: a choice taking, and a stamp landing.
   Not supported on iOS Safari, which is why nothing depends on it. Someone who has
   asked for less motion gets none of it. */

function allowed() {
  if (typeof navigator === "undefined" || typeof navigator.vibrate !== "function") return false;
  return !window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}

export const haptic = {
  tap() {
    if (allowed()) navigator.vibrate(10);
  },
  land() {
    if (allowed()) navigator.vibrate([14, 36, 44]);
  },
};
